import $ from 'jquery'

class BlockFeaturedNewsEvents extends window.HTMLDivElement {
  constructor () {
    super()
    this.$ = $(this)
    this.resolveElements()
  }

  resolveElements () {
  }

  connectedCallback () {
  }
}

window.customElements.define('flynt-block-featured-news-events', BlockFeaturedNewsEvents, {extends: 'div'})



// WEBPACK FOOTER //
// ./Components/BlockFeaturedNewsEvents/script.js